export default "__VITE_ASSET__CZ7R1dXi__"